export default __webpack_public_path__ + "static/media/REFIN_affrescati_LP_CONF_LAPIS-120X120.9e84f45d.jpg";